import { connect } from 'react-redux';
// eslint-disable-next-line import/no-named-as-default,import/no-named-as-default-member
import ConfigureStock from './ConfigureStock';
// import {
//   setSettingsPlantStorageTime,
//   sendFileStockSettings,
//   fetchStock
// } from '../../../store/actions/stock';
// import { modalMessageOpen } from '../../../store/actions/modal';
// import { modalErrorOpen } from '../../../store/actions/modalError';
import {
  getAvailableOperations,
  saveAvailableOperations,
  getConfigureStockAttributes,
  getInheritTypes,
  delConfigureStockAttribute,
  getAllOperations,
  getAllAttributes,
  saveConfigureStockAttributes,
  createOperation
} from '../../../store/actions/configurator';

const mapStateToProps = ({ configuratorReducer }) => ({
  configuratorReducer
});
const mapDispatchToProps = {
  getAvailableOperations,
  saveAvailableOperations,
  getConfigureStockAttributes,
  getInheritTypes,
  delConfigureStockAttribute,
  getAllOperations,
  getAllAttributes,
  saveConfigureStockAttributes,
  createOperation
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ConfigureStock);
